/**
 * @generated SignedSource<<ec31da3c6d0dcd0ea54b10c2046e27c3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EventCardFragment$data = {
  readonly competitions: {
    readonly totalCount: number;
  };
  readonly host: {
    readonly " $fragmentSpreads": FragmentRefs<"ActivityCardHostFragment">;
  };
  readonly id: string;
  readonly slug: string;
  readonly thumbnail: Url | null | undefined;
  readonly title: string;
  readonly visibility: ActivityVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityCardTagListFragment" | "EventCardFooterFragment" | "EventLocationFragment">;
  readonly " $fragmentType": "EventCardFragment";
};
export type EventCardFragment$key = {
  readonly " $data"?: EventCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityCardHostFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventCompetitionConnection",
      "kind": "LinkedField",
      "name": "competitions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventCardFooterFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityCardTagListFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventLocationFragment"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "537abe4b8d7120355565eb7c25b95e14";

export default node;
